<div class="row">
  <div class="col-12">
    <h1 class="h2 mb-7">{{ 'habaCustomerData.invoiceDownload.headline' | cxTranslate }}</h1>
    <h4>{{ 'habaCustomerData.invoiceDownload.part1Headline' | cxTranslate }}</h4>
    <p [innerHTML]="'habaCustomerData.invoiceDownload.part1Description' | cxTranslate"></p>
    <h4 class="mt-7">{{ 'habaCustomerData.invoiceDownload.part2Headline' | cxTranslate }}</h4>
    <p [innerHTML]="'habaCustomerData.invoiceDownload.part2Description' | cxTranslate"></p>
  </div>
  <div class="col-12 col-md-8 col-lg-6">
    <form [formGroup]="invoicePdfDownload" class="mt-7">
      <app-form-input>
        <app-form-label>{{
          'habaCustomerData.invoiceDownload.inputCustomerNr' | cxTranslate
        }}</app-form-label>
        <input appFormInput type="text" formControlName="customerNr" />
        <app-form-error>{{
          'habaCustomerData.invoiceDownload.inputCustomerNrError' | cxTranslate
        }}</app-form-error>
      </app-form-input>
      <app-form-input>
        <app-form-label>
          {{ 'habaCustomerData.invoiceDownload.inputInvoiceNr' | cxTranslate }}</app-form-label
        >
        <input appFormInput type="text" formControlName="invoiceNr" />
        <app-form-error>{{
          'habaCustomerData.invoiceDownload.inputInvoiceNrError' | cxTranslate
        }}</app-form-error>
      </app-form-input>

      <div class="form-group mt-9">
        <label>{{ 'habaCustomerData.invoiceDownload.submitButton' | cxTranslate }}</label>
        <button
          class="btn btn-primary btn-full"
          (click)="getInvoicePdfDownload()"
          [disabled]="invoicePdfDownload.invalid"
        >
          <span class="px-4" [attr.style]="invoicePdfDownload.invalid ? '--svg-color: white' : ''">
            <app-svg iconName="Download" dimension="1.5rem"></app-svg>
          </span>
        </button>
      </div>
    </form>
  </div>
  <p class="col-12">
    {{ 'habaContactForm.whenStuck' | cxTranslate }}
    <a [routerLink]="contactFormUrl" target="_blank" rel="noopener noreferrer">
      {{ 'habaContactForm.formular' | cxTranslate }}</a
    >.
  </p>
</div>
